// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"TrxStockOutModal_sectionWrapper__1w7Te"};